import { searchParametersActions, selectBrand, selectBrandFilterContext } from 'features/searchResultsFacets';
import { map, distinctUntilChanged, filter, fromEvent, skip } from 'rxjs';

import { store, store$ } from '@redux/store';

const selectContainer = document.querySelector('[data-builders-filter]');
const selectUserChange$ = fromEvent(selectContainer, 'change');

/**
 * Here we manage when the user modify the select UI element.
 */
selectUserChange$.subscribe((event) => {
  const selectElement = event.target;
  const builderId = selectElement.value;
  const builderName = builderId ? selectElement.options[selectElement.selectedIndex].text : '';
  const brand = { name: builderName, id: builderId };
  store.dispatch(searchParametersActions.fetchBrandId({ brand }));
});

/**
 * Function used to clear all the options in a select, with the exception of the first option
 */
function clearSelectOptions(){
  for (let index = selectContainer.options.length - 1; index > 0; index -= 1) {
    selectContainer.remove(index);
  }
}

/**
 * Function used to replace all the options in a select, with the exception of the first option
 * @param {Array} options All the options available.
 */
function replaceOptionsInSelect(data) {
  const { brands, brandId } = data;
  if (brands) {
    
    clearSelectOptions();

    // Add new options
    brands.forEach((option) => {
      const optionElement = document.createElement('option');
      optionElement.value = option.Id;
      optionElement.text = option.Name;
      selectContainer.add(optionElement);

      if(option.Id === Number(brandId)) {
        optionElement.selected = true;
      }
    });
  }
}

const onBuilderChange$ = store$.pipe(map(selectBrand), filter(Boolean), distinctUntilChanged());
onBuilderChange$.subscribe((brand) => {
  const { brandId } = brand;

  const allBuildersOption = selectContainer.children[0];
  const selectedItem = selectContainer.querySelector(`[value="${brandId}"]`) || allBuildersOption;

  selectedItem.selected = true;
});

const onResultLoad$ = store$.pipe(map(selectBrandFilterContext), filter(Boolean), distinctUntilChanged(), skip(1));
onResultLoad$.subscribe(replaceOptionsInSelect);
